export const numberOnly = (e) => {
    if (e.target.value.match(/[^0-9]/g)) {
        e.target.value = e.target.value.replace(/[^0-9]/g, '');
    }
};